import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'CREATE_REFERENCE';

export async function createReference(
    userToken: string,
    newReference: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'post',
            url: `${URL}/references/`,
            data: newReference,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        const errorMessage = () => {
            return 'Une erreur de la création d\'une reference';

        };

        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: errorMessage(),
            error: error
        });
    }
}
